import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type InvoiceQuery = { __typename?: 'Query', invoice?: { __typename?: 'InvoiceNode', id: string, customerName?: string | null, phone?: string | null, currency: Types.PaymentInvoiceCurrencyChoices, vatRate: number, vatPrice: number, vatIndexPriceDiff?: number | null, idAsString?: string | null, totalPrice: number, notes?: string | null, chargedIndex: number, chargeDate?: any | null, baseRentalPrice?: number | null, baseLicenceAndInsurancePrice?: number | null, baseMaintenancePrice?: number | null, dealIds?: string | null, creationTime?: any | null, customer?: { __typename?: 'CustomerNode', id: string, name: string, email?: string | null } | null } | null };


export const InvoiceDocument = gql`
    query invoice($id: ID!) {
  invoice(id: $id) {
    id
    customer {
      id
      name
      email
    }
    customerName
    phone
    currency
    vatRate
    vatPrice
    vatIndexPriceDiff
    idAsString
    totalPrice
    notes
    chargedIndex
    chargeDate
    baseRentalPrice
    baseLicenceAndInsurancePrice
    baseMaintenancePrice
    dealIds
    creationTime
  }
}
    `;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;